import { Box, Pagination } from "@mui/material";

export default function TablePaging({maxPage, page, changePage}) {

  return (
    <Box textAlign="center">
      <Pagination
        count={maxPage}
        page={page}
        variant="outlined"
        shape="rounded"
        onChange={(_, page) => changePage(page)}
        defaultPage={1}
        sx={{ mt: 1, display: "inline-block" }}
      />
    </Box>
  )

}
